import { Component, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addroutemaster',
  template: require('./addroutemaster.component.html'),
  styles: [],
})
export class AddRouteMasterComponent implements OnInit {

  model: NgbDateStruct;

  constructor(
  ) { }

  ngOnInit() {
  }


}
